module.exports = __webpack_public_path__ + "img/cg-mob-2.53b0acda.svg";